require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-helps-raise-over-usd-66-000-for-fox-59-s-pack-the-pantries.json") })
        }
      }, "path---articles-financial-center-helps-raise-over-usd-66-000-for-fox-59-s-pack-the-pantries");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-helps-raise-over-usd-66-000-for-fox-59-s-pack-the-pantries!./.cache/json/articles-financial-center-helps-raise-over-usd-66-000-for-fox-59-s-pack-the-pantries.json
// module id = 1630
// module chunks = 231608221292675